import React from 'react';
import { useBooking, Service } from '../context/BookingContext';
import { ArrowRightIcon } from 'lucide-react';
export const ServiceSelection = () => {
  const {
    booking,
    setBooking,
    nextStep
  } = useBooking();
  const services: Service[] = [{
    id: '1',
    name: 'Haircut & Styling',
    description: 'Professional haircut and styling tailored to your preferences.',
    duration: 60,
    price: 85,
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '2',
    name: 'Hair Coloring',
    description: 'Full hair coloring service with premium products for vibrant, long-lasting color.',
    duration: 120,
    price: 120,
    image: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '3',
    name: 'Balayage',
    description: 'Hand-painted highlights creating a natural, sun-kissed look.',
    duration: 150,
    price: 180,
    image: 'https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '4',
    name: 'Blowout & Styling',
    description: 'Professional blow dry and styling for a perfect finish.',
    duration: 45,
    price: 65,
    image: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }];
  const handleSelectService = (service: Service) => {
    setBooking(prev => ({
      ...prev,
      service
    }));
    nextStep();
  };
  return <div data-id="element-155">
      <h3 className="text-xl font-medium text-amber-400 mb-4" data-id="element-156">
        Select a Service
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-157">
        {services.map(service => <div key={service.id} className={`border rounded-lg overflow-hidden cursor-pointer transition-all hover:shadow-md ${booking.service?.id === service.id ? 'border-amber-500 ring-2 ring-amber-500/30' : 'border-blue-800'}`} onClick={() => handleSelectService(service)} data-id="element-158">
            <div className="h-48 overflow-hidden" data-id="element-159">
              <img src={service.image} alt={service.name} className="w-full h-full object-cover" data-id="element-160" />
            </div>
            <div className="p-4 bg-blue-900" data-id="element-161">
              <div className="flex justify-between items-start mb-2" data-id="element-162">
                <h4 className="text-lg font-medium text-amber-300" data-id="element-163">
                  {service.name}
                </h4>
                <span className="font-medium text-amber-400" data-id="element-164">
                  ${service.price}
                </span>
              </div>
              <p className="text-blue-100 text-sm mb-3" data-id="element-165">
                {service.description}
              </p>
              <div className="flex justify-between items-center" data-id="element-166">
                <span className="text-sm text-blue-300" data-id="element-167">
                  {service.duration} min
                </span>
                <button className="flex items-center gap-1 text-sm font-medium text-amber-400 hover:text-amber-300" data-id="element-168">
                  Select <ArrowRightIcon className="w-4 h-4" data-id="element-169" />
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};